'use client';
import AppLayout from '@/components/AppLayout';
import SuppliersContent from './components/SuppliersContent';

export default function SuppliersPage() {
  return (
    <AppLayout>
      <SuppliersContent />
    </AppLayout>
  );
}
